import { black, blue, gray } from "./colors";

let fontFamily = "var(--font-sans), system-ui, sans-serif";

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

// SKIM to do: We need to review all of these
export const fontSize = {
  disclaimer: "0.625rem", // 10px
  smaller: "0.75rem", // 12px
  small: "0.875rem", // 14px
  base: "1rem", // 16px
  large: "1.125rem", // 20px
  large2: "1.375rem", // 22px
  mobileHeader: "1.5rem", // 24px
  header: "2rem", // 32px
};

export const letterSpacing = {
  base: "0rem",
  105: "0.05rem",
};

export const text = {
  primary: black[100],
  secondary: gray[80],
  placeholder: gray[60],
  inactive: gray[40],
  hover: blue[100],
};

/**
 * If you add variants, make sure you add them to the shared MUI type
 *
 * @see portal/types/material.d.ts
 */
const typography = {
  fontFamily,
  title2: {
    fontSize: fontSize.large2,
    fontWeight: fontWeight.bold,
    lineHeight: "1.75rem", // 28px
    letterSpacing: letterSpacing.base,
  },
  body2: {
    letterSpacing: letterSpacing[105],
    fontSize: fontSize.small,
  },
  infoAlert: {
    fontFamily,
    fontSize: 14,
    fontWeight: fontWeight.regular,
    lineHeight: "20px",
    color: gray[90],
  },
};

export default typography;
